import React, { useState, useEffect } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl, FormattedDate } from 'react-intl'
import { reduxForm, change } from 'redux-form'
import { useTheme, withStyles } from '@material-ui/core'
import { Button, Menu, MenuItem, ListItemText, Grid, Badge, Typography } from '@material-ui/core';
import { getCases, setCurrentCase } from '../../../redux/actions'
import { casesListSelector, currentCaseSelector } from '../../../redux/selectors'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    badge: {
        fontSize: "1rem",
        fontWeight: 900,
        backgroundColor: "#ab003c",
        color: "white", 
        marginRight: '8px'
    },
    bellBadge: {
        backgroundColor: "#ab003c",
        marginRight: '8px'
    }
}))

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5'
    },
    popoverPaper: {
        minWidth: '288px',
        marginRight: '10px',
        maxHeight: 'unset',
        maxWidth: 'unset',
    }
})((props) => (
    <Menu
        PopoverClasses={{ paper: props.classes.popoverPaper }}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({}))(MenuItem);

const CaseSwitcher = ({ intl, cases, loadCases, currentCase, setCase }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const theme = useTheme();
    const classes = useStyles();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event) => {
        if (event.currentTarget.dataset.id) {
            setCase(event.currentTarget.dataset.id)
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
            loadCases()
        },
        []);

    return (
        <div>
            <Button
                style={{ margin: '0' }}
                data-testid="change-case-switcher-button"
                aria-controls="customized-menu"
                aria-haspopup="true"
                variant="contained"
                color="primary"
                startIcon={
                    cases && cases.some(x => x.unReadUpdatesCount > 0)
                        ?
                        <Badge badgeContent=" " classes={{ badge: classes.bellBadge }} variant="dot">
                            <NotificationsIcon />
                        </Badge>
                        :
                        <NotificationsIcon />
                }
                endIcon={<ExpandMoreIcon />}
                onClick={handleClick}
            >
                {intl.formatMessage({ id: 'app.case.change' })}
            </Button>
            <ThemeProvider theme={theme}>
                <StyledMenu
                    data-testid="change-case-switcher-select"
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {
                        cases && cases.length > 0 && cases.map((item, index) =>
                            <StyledMenuItem selected={currentCase && currentCase.id === item.id} data-id={item.id} key={item.id} onClick={handleMenuItemClick}>
                                <ListItemText primary=
                                    {
                                        <Grid container spacing={2} style={{ borderBottom: '1px #ccc solid'}}>
                                            {item.unReadUpdatesCount > 0 && 
                                                <Grid item style={{ textAlign: 'center', padding: '8px 8px 8px 24px' }}>
                                                    <Badge badgeContent={item.unReadUpdatesCount} classes={{ badge: classes.badge }} />
                                                </Grid>
                                            }
                                            <Grid item >
                                                <Typography variant='subtitle1'>
                                                    ID: {item.caseId}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle1' style={{ color: '#666666' }}>
                                                    <FormattedDate year='numeric' month='short' day='2-digit' value={item.commencementDate} />
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle1' style={{ whiteSpace: 'normal' }}>
                                                    {item.protocolAlias || item.protocolName}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    }
                                />
                            </StyledMenuItem>)
                    }
                </StyledMenu>
            </ThemeProvider>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => ({
    cases: casesListSelector(state),
    currentCase: currentCaseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadCases: () => dispatch(getCases()),
    setCase: (caseId) => dispatch(setCurrentCase(caseId)),
})

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)

export default enhance(CaseSwitcher)
